import { Auth } from 'aws-amplify';
import { removeAuthToken } from './token';

export function logout(callback) {
  Auth.signOut();
  removeAuthToken();

  callback();
}
